import { Dayjs } from "dayjs";

import {
  ValidationError,
  ValidationParams,
  ValidationPropsType,
} from "@/types/validation";

export function handleChange<T, V = T>(params: ValidationParams<T, V>) {
  const { field, parentField, setEntity, value } = params;

  const fieldValidations = params.validation[field];

  let isValid = true;
  let fieldValidation = fieldValidations[0];

  if (typeof value === "string") {
    // set the value of the field
    if (!parentField)
      setEntity((prev) => ({ ...(prev ?? {}), [field]: value } as T));
    // nest if there is a parent field
    else
      setEntity((prev) =>
        prev
          ? {
              ...prev,
              [parentField]: { ...prev[parentField], [field]: value },
            }
          : ({
              [parentField]: { [field]: value },
            } as T)
      );
  } else if (typeof value === "object") {
    if (params.setDate) params.setDate(value); // set the Dayjs value every time

    if (value && value.isValid())
      !parentField
        ? // set the string value of the field if it is valid
          setEntity(
            (prev) =>
              ({ ...(prev ?? {}), [field]: value.format("MM/DD/YYYY") } as T)
          )
        : setEntity((prev) =>
            prev
              ? {
                  ...prev,
                  [parentField]: {
                    ...prev[parentField],
                    [field]: value.format("MM/DD/YYYY"),
                  },
                }
              : ({
                  [parentField]: { [field]: value },
                } as T)
          );
  }

  if (!value) {
    isValid = false;
  } else {
    for (let i = 0; i < fieldValidations.length && isValid; ++i) {
      fieldValidation = fieldValidations[i];
      isValid =
        typeof value === "object"
          ? validateDate(value, fieldValidation)
          : validateString(value, fieldValidation, params.confirmationValue);
    }
  }

  if (!isValid) {
    // return a new object with that field
    params.setErrors((prev) => ({
      ...prev,
      [field]: fieldValidation.message,
    }));
  } else {
    // return a new object without that field
    params.setErrors((prev) => {
      const { [field]: _, ...rest } = prev;
      return rest as ValidationError<V>;
    });
  }
}

function validateDate(value: Dayjs, validation: ValidationPropsType) {
  if (!value.isValid()) return false;

  const stringValue = value.format("MM/DD/YYYY");

  if (
    !stringValue.match(validation.regex) ||
    ("maxDate" in validation &&
      "minDate" in validation &&
      (value > validation.maxDate || value < validation.minDate))
  )
    return false;

  return true;
}

function validateString(
  value: string,
  validation: ValidationPropsType,
  confirmationValue?: string
) {
  if (
    "confirmation" in validation &&
    (!confirmationValue || !validation.confirmation(value, confirmationValue))
  ) {
    return false;
  } else if (!value.match(validation.regex)) return false;

  return true;
}
